import { useAppContext } from '../../../../../app/Context';
import { usePollContext } from '../../../Context';
import { getIsPollPublished } from '../../helpers';

const usePollTitle = () => {
  const { isPresenting } = useAppContext();

  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);

  return { isPollPublished, isPresenting };
};

export default usePollTitle;
